// @flow
const BASE_URL = 'https://www.finect.com';

const getBreadcrumbSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    {
      '@type': 'ListItem',
      position: 1,
      name: 'Inicio',
      item: BASE_URL
    },
    {
      '@type': 'ListItem',
      position: 2,
      name: 'Asesores financieros',
      item: `${BASE_URL}/asesores`
    }
  ]
});

const getFAQSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '¿Cuánto cobra un asesor financiero?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Existen asesores financieros accesibles y más rentables de lo que imaginas. El coste varía según el tipo de asesor: los independientes suelen cobrar honorarios por hora o un porcentaje del patrimonio gestionado, mientras que los vinculados a entidades financieras pueden no tener coste directo para el cliente.'
      }
    },
    {
      '@type': 'Question',
      name: '¿Necesitas tener un asesor financiero?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Un especialista financiero puede ser de enorme ayuda para gestionar tu dinero, tanto para preservarlo como para buscarle rentabilidad. Conocerá tus metas personales y te ayudará a alcanzarlas con una estrategia adaptada a tu perfil de riesgo.'
      }
    },
    {
      '@type': 'Question',
      name: '¿Cómo tiene que ser tu asesor financiero?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Tu asesor financiero debe ser un profesional cuyo único interés sea tu bienestar financiero. Debe conocer muy bien tus metas y, en base a esta información, ayudarte a organizar tus ahorros e inversiones para alcanzar esos objetivos.'
      }
    },
    {
      '@type': 'Question',
      name: '¿De qué hablar con tu asesor financiero?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'En las conversaciones con tu asesor financiero debes hablar principalmente de tus proyectos y objetivos de vida, más que de productos o rentabilidades concretas. Eso llegará después, una vez que el asesor conozca bien tu situación y metas.'
      }
    }
  ]
});

const getItemListSchema = (provinces: Array<Object>) => ({
  '@context': 'https://schema.org',
  '@type': 'ItemList',
  name: 'Asesores financieros por provincia',
  description: 'Encuentra asesores financieros en todas las provincias de España.',
  itemListElement: [...provinces]
    .sort((a, b) => a.province.localeCompare(b.province, 'es'))
    .map((province, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: `Asesores financieros en ${province.province}`,
      url: `${BASE_URL}/asesores/encuentra-un-asesor/en/${province.slug}`
    }))
});

// Servicio de asesoramiento + cobertura geográfica (refuerza el SEO local del bloque de
// provincias). `areaServed` enlaza con las provincias del listado.
const getServiceSchema = (provinces: Array<Object>) => ({
  '@context': 'https://schema.org',
  '@type': 'Service',
  serviceType: 'Asesoramiento financiero',
  name: 'Asesores financieros',
  description:
    'Servicio gratuito de Finect para encontrar asesores financieros que te ayuden a planificar tus finanzas e inversiones.',
  provider: {
    '@type': 'Organization',
    name: 'Finect',
    url: BASE_URL
  },
  areaServed: [...provinces]
    .sort((a, b) => a.province.localeCompare(b.province, 'es'))
    .map(province => ({
      '@type': 'AdministrativeArea',
      name: province.province
    })),
  url: `${BASE_URL}/asesores`
});

export const getBreadcrumbSchemaJSON = () => JSON.stringify(getBreadcrumbSchema());
export const getFAQSchemaJSON = () => JSON.stringify(getFAQSchema());
export const getItemListSchemaJSON = (provinces: Array<Object>) => JSON.stringify(getItemListSchema(provinces));
export const getServiceSchemaJSON = (provinces: Array<Object>) => JSON.stringify(getServiceSchema(provinces));
